<template>
    <div :class="`toast ${show ? 'active' : ''} ${icon == 'exclamation' ? 'text-dark' : 'text-white'} bg-${theme} border-0`" :style="`${icon == 'check' ? 'bottom: 25px;' : 'top: 25px;'}`" role="alert" aria-atomic="true">
        <div class="d-flex justify-content-between align-items-center">
            <i :class="`fas fa-${icon} toast-icon`"></i>
            <div class="toast-body">
                {{ message }}
            </div>
            <button @click="closeToast()" type="button" data-bs-dismiss="toast" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div :class="`progress-bar-toast ${show ? 'active' : ''}`" :style="`--timer-toast: ${timer}s`"></div>
    </div>  
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Toast',
    methods: {
        ...mapActions("toast", [
            "setShowToast",
            "setTimerToast"
        ]),
        closeToast() {
            this.setShowToast(false)
        }
    },
    computed: {
        ...mapState("toast", [
            "show",
            "message",
            "icon",
            "theme",
            "timer"
        ])
    }
}
</script>

<style scoped>
.toast {
    position: fixed;
    right: 30px;
    transform: translateX(calc(100% + 30px));
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.35);

    padding: 1rem 0 1rem 1.8rem;
    border-radius: 0.25rem;
    width: 300px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    height: auto;
    overflow: hidden;
}

.toast .progress-bar-toast {
    height: 3px;
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    position: absolute;
    left: 0;
    bottom: 0;
}

.toast .progress-bar-toast::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.4);
}

.toast .progress-bar-toast.active::before {
    animation: progress var(--timer-toast) linear forwards;
}

@keyframes progress {
    100% {
        right: 100%;
    }
}

.toast.active {
    transform: translateX(0%);
}

@media (max-width: 350px) {
    .toast {
        width: 240px;
    }
}

.toast .toast-icon {
    font-size: 2.5rem;
    padding-right: 1.6rem;
    color: rgba(0, 0, 0, 0.3);
}

.toast .toast-body {
    font-size: 1.4rem;
}

.toast button {
    border: none;
    outline: none;
    background: transparent;
    padding: 0 1.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.toast button i {
    font-size: 2rem;
    color: rgba(0, 0, 0, 0.3);
}
</style>